import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'letra_taxonomy',
  type: 'taxonomy_term--letra',
  attributes: {
    maximo: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'maximo',
    },
    minimo: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'minimo',
    },
    nombre: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'nombre',
    },
    precio: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'precio',
    },
  },
  relationships: {},
};

export const TaxonomyLetraService = createService(base, configuration, API_CONFIG.API);
export const TaxonomyLetraModule = createModule(TaxonomyLetraService, true);



// WEBPACK FOOTER //
// ./src/models/taxonomyLetra.js